export class MoveDeposeZoneTerrainDto {
    DeposeZoneTerrainCode!: string;
    Date!: string;
}